import styled from "styled-components";
import { Badge } from "react-bootstrap";

const TagBadge = styled(Badge)`
  background-color: var(--aa-tag-bg) !important;
  color: var(--aa-tag-color) !important;
  font-family: monospace;
  font-weight: normal;
  font-size: 12px !important;
`;

export const AgencyTag = ({ tag }: { tag: string }) => {
  return <TagBadge bg="secondary">{tag}</TagBadge>;
};

export const AgencyTags = ({
  tags,
  className,
}: {
  tags?: string[];
  className?: string;
}) => {
  return tags?.length ? (
    <div
      className={`d-flex flex-wrap gap-1${className ? ` ${className}` : ""}`}
    >
      {tags?.map((tag) => (
        <AgencyTag key={tag} tag={tag} />
      ))}
    </div>
  ) : null;
};
